import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import {captureException} from "@/errorHelper";

window._ = require('lodash');


/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    // window.$ = window.jQuery = require('jquery');

    // require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

try {
  window.Pusher = Pusher;

  window.Echo = new Echo({
      broadcaster: 'reverb',
      key: process.env.MIX_REVERB_APP_KEY,
      wsHost: process.env.MIX_REVERB_HOST,
      wsPort: process.env.MIX_REVERB_PORT,
      wssPort: process.env.MIX_REVERB_PORT,
      forceTLS: (process.env.MIX_REVERB_SCHEME ?? 'https') === 'https',
      enabledTransports: ['ws', 'wss'],
      debug: true,
  });
} catch (e) {
  captureException(e);
  console.error('Echo Error', e);
}

window.mixpanel = async (label, parameters = null) => {
    try {
        await axios.post('/mixpanel', {label, parameters});
    } catch {
        // do nothing
    }
};
